import axios, { AxiosPromise } from "axios";
import Credentials from "../models/users/Credentials";

interface LoginResponse {
    status?: string;
    email?: string;
    userId?: string;
    preferredMethod?: string;
    token?: string;
    twoFactorAppName?: string;
    message?: string;
    user?: {
        email: string;
        nombre: string;
        apellidos: string;
        twoFactorEnabled: boolean;
        preferredMethod?: string;
        twofactorinterval?: number;
    };
}

export function login(credentials: Credentials): AxiosPromise<string | LoginResponse> {
    return axios.post('api/auth/login', credentials);
}

interface Verify2FAResponse {
    status?: string;
    token?: string;
    user?: any;
    message?: string;
}

export function verify2FA(email: string, code: string, method: string): AxiosPromise<string | Verify2FAResponse> {
    return axios.post('api/auth/verify-2fa', { email, code, method });
}

export function sendEmailCode(email: string): AxiosPromise<{ message: string }> {
    return axios.post('api/auth/send-email', { email });
}

export function enable2FA(email: string, method: string, interval: number, code?: string): AxiosPromise<{ message: string }> {
    return axios.post('api/auth/enable-2fa', { email, method, interval, code });
}

interface Setup2FAResponse {
    qrCodeUrl: string;
    secret: string;
    manualEntryKey: string;
    backupCodes: string[];
}

export function setup2FA(email: string): AxiosPromise<Setup2FAResponse> {
    return axios.post('api/auth/setup-2fa', { email });
}

const API_URL = process.env.REACT_APP_API_URL || '';

export const confirm2FASetup = (email: string, code: string, appName?: string) => {
    return axios.post('/api/auth/confirm-2fa-setup', { email, token: code, appName });
}

export function updateInterval(email: string, interval: number): AxiosPromise<{ message: string; interval: number }> {
    return axios.post('api/auth/update-interval', { email, interval });
}

export function regenerateBackupCodes(email: string): AxiosPromise<{ backupCodes: string[] }> {
    return axios.post('api/auth/regenerate-backup-codes', { email });
}


export function recuperarContrasena(email: string): AxiosPromise<{ message: string }> {
    return axios.post('api/auth/recuperar-contrasena', { email });
}

export function cambiarContrasenaTemporal(nuevaContrasena: string): AxiosPromise<{ token: string }> {
    return axios.post('api/auth/cambiar-contrasena-temporal', { nuevaContrasena });
}
